export default "__VITE_ASSET__DNo1ZNxZ__"